const buttons = (state = "0", action) => {
    switch (action.type) {
        case 'ADD_BUTTON':
        case 'REMOVE_BUTTON':
        case 'SET_CURRENT_BUTTON':
            return action.buttonID
        default :
            return state
    }
}

export default buttons